import ModernHeader from "./components/ModernHeader";
import { Routes, Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import Error from "./components/Error";
import SmoothScroll from "./components/SmoothScroll";
import CustomCursor from "./components/CustomCursor";

function App() {
  return (
    <>
      <CustomCursor />
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<ModernHeader />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </>
  );
}

export default App;
